export default __webpack_public_path__ + "src/assets/logo-text-blue.fca091643b0da50d1a535091f6d1cabc.svg";